export default "__VITE_ASSET__CDNmFNAs__"